export const userKeys = {
	all: ['mantang'] as const,
	profile: () => [...userKeys.all, 'profile'] as const,
	userCarInfo: () => [...userKeys.profile(), 'userCarInfo'] as const,
	favorites: () => [...userKeys.profile(), 'favorites'] as const,
	favorite: (stationId: string) =>
		[...userKeys.favorites(), stationId] as const,
};
